import { Button, Dialog } from "@app/ui";

import { useI18n } from "../../lib/useI18n.js";

/** Confirm-delete dialog shared by all three Organize panels. */
export function DeleteEntityDialog({
  name,
  body,
  confirmLabel,
  onConfirm,
  onClose,
}: {
  /** Entity name; null/undefined = dialog closed. */
  name: string | null | undefined;
  body: string;
  confirmLabel: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const { t } = useI18n();
  return (
    <Dialog
      open={name != null}
      onClose={onClose}
      title={name != null ? t("lists.deleteNamed", { name }) : undefined}
      className="max-w-md"
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-foreground">{body}</p>
        <div className="flex flex-col gap-2">
          <Button variant="destructive" onClick={onConfirm}>{confirmLabel}</Button>
          <Button variant="ghost" onClick={onClose}>{t("common.cancel")}</Button>
        </div>
      </div>
    </Dialog>
  );
}
